import { useTheme } from '@mui/material/styles';
import { HelpOutlineOutlined } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { DetailsType } from '../../../../../../common/details-list/interface';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';
import { convertSecondsToTimeFormat } from '../../../../../../../constants/helpers/dates';

import { Operation } from './interfaces';

interface Props {
  operation: Operation;
  detailsType: DetailsType;
}

const SuccessOperation = ({ operation, detailsType }: Props) => {
  const theme = useTheme();
  const {
    duration,
    customerMsisdn,
    appId,
    operator,
    sessionType,
    sessionTag,
    sessionCloseReason,
    sessionAbortReason,
    dialedAppId
  } = operation;
  const items = [
    { label: locales.operation.label.duration, value: convertSecondsToTimeFormat(duration) },
    { label: locales.operation.label.operatorName, value: operator },
    {
      label: locales.operation.label.phoneNumber,
      value: detailsValueFormatter(customerMsisdn)
    },
    { label: locales.operation.label.appId, value: appId },
    { label: locales.operation.label.sessionType, value: sessionType },
    { label: locales.operation.label.sessionTag, value: sessionTag },
    { label: locales.operation.label.sessionCloseReason, value: sessionCloseReason }
  ];

  if (dialedAppId != null) {
    items.push({ label: locales.operation.label.dialedAppId, value: dialedAppId });
  }
  if (sessionAbortReason != null) {
    items.push({ label: locales.operation.label.sessionAbortReason, value: sessionAbortReason });
  }
  return (
    <DetailsFactory
      detailsType={detailsType}
      header={{
        icon: { component: HelpOutlineOutlined, color: theme.palette.grey['700'] },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={<DetailsList items={items} />}
    />
  );
};

export default SuccessOperation;
